export default "__VITE_ASSET__yK7pos$4__"